import { render, staticRenderFns } from "./UpdateWorkspaceObjectNameModal.vue?vue&type=template&id=fbaec844&"
import script from "./UpdateWorkspaceObjectNameModal.vue?vue&type=script&lang=ts&"
export * from "./UpdateWorkspaceObjectNameModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateWorkspaceObjectNameModal.vue?vue&type=style&index=0&scope=true&lang=scss&"
import style1 from "./UpdateWorkspaceObjectNameModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports